/* eslint-disable import/export */
import * as apply from 'fp-ts/Apply';
import * as either from 'fp-ts/Either';
import { constUndefined, flow, identity, pipe } from 'fp-ts/function';
import { getSemigroup } from 'fp-ts/NonEmptyArray';
import * as predicate from 'fp-ts/Predicate';
import * as chain from './chain.js';
import * as functor from './functor.js';
export * from 'fp-ts/Either';
export const getOrThrow = (toThrowable) => (e) => pipe(e, either.fold((err) => {
    throw toThrowable(err);
}, (a) => a));
export const sequenceS = apply.sequenceS(either.Applicative);
export const sequenceT = apply.sequenceT(either.Applicative);
export const sequenceTW = sequenceT;
export const bindSequenceS = chain.bindSequenceS(either.Chain);
export const bindSequenceSW = bindSequenceS;
export const bindS = chain.bindS(either.Chain);
export const bindSW = bindS;
export const letS = functor.letS(either.Functor);
export const chainSequenceS = chain.chainSequenceS(either.Chain);
/**
 * A variant of {@link stopIf} that allows the left part of the Either to be widened.
 */
export const stopIfW = (p, onTrue) => either.filterOrElseW(predicate.not(p), onTrue);
/**
 * This is the negation of {@link filterOrElse}. If the predicate returns `true`, a `Left` is
 * returned, using the `onTrue` value. Otherwise, the `Right` is passed through.
 *
 * @see stopIfW
 */
export const stopIf = stopIfW;
// -----------------------------------------------------------------------------------------------
// Validation
/**
 * Lift an Either-returning function into a validation context, so we can accumulate
 * data on the left side.
 */
export const liftValidation = (check) => (x) => pipe(check(x), either.mapLeft((y) => [y]));
/**
 * Turn a list of Eithers into an Either with the errors aggregated into a
 * non-empty array.
 *
 * @see https://dev.to/gcanti/getting-started-with-fp-ts-either-vs-validation-5eja
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getValidationSequenceT = () => apply.sequenceT(either.getApplicativeValidation(getSemigroup()));
export const existsLeft = (p) => flow(either.swap, either.exists(p));
export const fromNullable = (e) => (a) => a == null ? either.left(e()) : either.of(a);
export const fromBoolean = (onFalse, onTrue) => (condition) => condition ? either.right(onTrue()) : either.left(onFalse());
export const guard = (onFalse) => (condition) => condition ? either.right(undefined) : either.left(onFalse());
export const toUndefined = either.fold(constUndefined, identity);
export function flatTraverse(F) {
    return (f) => flow(either.traverse(F)(f), (fa) => F.map(fa, either.flattenW));
}
export function flatTraverseOptionK(F) {
    return (f, onNone) => flow(either.traverse(F)(f), (fa) => F.map(fa, either.chainW(either.fromOption(onNone))));
}
//# sourceMappingURL=either.js.map